import React from 'react'
import cx from 'classnames'

import s from './base.scss'


const Square = ({ className }) => <div className={cx(s.square, className)} />


export default Square
